import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
const css = `
.param-dock {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    gap: 8px;
    padding: 8px 12px;
    padding-bottom: calc(8px + env(safe-area-inset-bottom));
    background: rgb(206 227 255 / 24%);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-top: 0.5px solid rgba(0, 0, 0, 0.08);
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    z-index: 900;
    pointer-events: auto;
}

.param-dock::-webkit-scrollbar {
    display: none;
}

.param-dock > * {
    flex-shrink: 0;
}

@media (min-width: 768px) {
    .param-dock {
        left: 50%;
        right: auto;
        bottom: 16px;
        transform: translateX(-50%);
        max-width: calc(100% - 32px);
        border-radius: 14px;
        border: 0.5px solid rgba(0, 0, 0, 0.08);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
        padding: 8px;
        padding-bottom: 8px;
    }
}
`;
const DockContext = createContext(null);
/**
 * Используется внутри детей ParamDock для управления своим состоянием «открыт/закрыт».
 * Если компонент используется вне ParamDock — fallback на локальный state, работает автономно.
 */
export function useDock(id) {
    const ctx = useContext(DockContext);
    const [localOpen, setLocalOpen] = useState(false);
    if (ctx) {
        return {
            isOpen: ctx.openId === id,
            toggle: () => ctx.toggle(id),
            open: () => ctx.open(id),
            close: ctx.close,
        };
    }
    return {
        isOpen: localOpen,
        toggle: () => setLocalOpen(o => !o),
        open: () => setLocalOpen(true),
        close: () => setLocalOpen(false),
    };
}
export function ParamDock({ children }) {
    const [openId, setOpenId] = useState(null);
    const toggle = useCallback((id) => {
        setOpenId(prev => (prev === id ? null : id));
    }, []);
    const open = useCallback((id) => {
        setOpenId(id);
    }, []);
    const close = useCallback(() => {
        setOpenId(null);
    }, []);
    // Esc — закрыть любую открытую панель
    useEffect(() => {
        if (!openId)
            return;
        const onKey = (e) => {
            if (e.key === 'Escape')
                close();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [openId, close]);
    return (_jsxs(DockContext.Provider, { value: { openId, toggle, open, close }, children: [_jsx("style", { children: css }), _jsx("div", { className: "param-dock", onClick: e => e.stopPropagation(), children: children })] }));
}
